<template>
  <PromoPage
    v-if="promo"
    type-page="planning"/>
  <div
    v-else
    id="planning"
    class="planning pt-8 px-5">
    <LowBalanceAlert/>
    <v-card
      class="planning-card main__green pr-3 "
      elevation="0">
      <v-row class="justify-space-between">
        <v-col class="pb-2 col-3">
          <v-card-title
            class=" h2-headline text-start"
            data-qa="planning">
            {{ $t('Menu.Planning') }}
          </v-card-title>
        </v-col>
        <TableFilters
          :all-headers="headers"
          :categories-data="categoriesData"
          :choosed-headers.sync="choosedHeaders"
          :creators="creators"
          :custom-class="'planing-filters'"
          :departaments-data="departamentsData"
          :loading="loading"/>
      </v-row>
      <sDivider
        class="mx-2"
        color="var(--v-main__light_green-base)"/>
      <v-card-text
        id="components"
        class="pa-0 pt-4">
        <EmptyBlock
          v-if="isEmpty"
          :text="$t('Tenders.NoData' )"/>
        <sIcon
          v-if="loading"
          class="align-self-center my-3"
          color="var(--white-color)"
          size="30"
          spin
          type="loading"/>
        <v-expansion-panels
          v-else
          v-model="panel"
          accordion
          flat
          multiple
          :value="panel">
          <v-expansion-panel
            v-for="(group, groupIndex) in filtredGroups"
            :key="group.time"
            class="main__green pt-3">
            <v-expansion-panel-header class=" pl-3 pr-7 plan-header">
              <v-row
                :key="selectedCount"
                class="h4-headline justify-space-between font-weight-medium"
                :data-qa="`group-${groupIndex}`"
                no-gutters>
                <v-col
                  class="d-flex align-center group-title"
                  cols="4">
                  <span
                    class="pb-0"
                    :data-qa="`group-${groupIndex}-name`">{{ group.name }}</span>
                  <sChip
                    v-if="group.selectedItems && group.selectedItems.length"
                    class="h9-text"
                    data-qa="planing-selected-items"
                    :text="group.selectedItems.length"/>
                </v-col>
                <v-col
                  class="d-flex justify-end align-center mr-6"
                  :data-qa="`group-${groupIndex}-currency`">
                  {{ getSum(group.items) | formSum }} {{ getCurrencyName(group.items[0],getSum(group.items) ) }}
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <sDivider
              class="mx-2 mb-6"
              color="var(--v-main__light_green-base)"/>
            <v-expansion-panel-content
              :id="group.items.length + group.name + group.time"
              class="plan-items px-2 pb-3">
              <PlanItemsTable
                :key="group.items.length + group.name + group.time + filtredGroups.length + (filters.filters ? filters.filters.map(el => JSON.stringify(el)) : '0' )"
                ref="table"
                :all-headers="headers"
                :all_categories="all_categories"
                :choosed-headers="choosedHeaders"
                :creators="creators"
                :filters="filters"
                :group="group"
                :items.sync="group.items"
                @updateSelectedCount="updateSelectedCount"/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import PromoPage from 'components/errors/PromoPage.vue'
import TableFilters from 'components/planning/TableFilters.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import PlanItemsTable from 'components/planning/PlanItemsTable.vue'
import LowBalanceAlert from 'components/billing/LowBalanceAlert.vue'

import moment from 'moment'
import { snackbarMixin, filterSortMixin, modalMixin, storageMixin, filtersTemplatesMixin } from 'mixins'
import ApplicationApi from '@/api/applicationApi'

import NotificationApi from '@/api/notificationApi'
import { mapGetters } from 'vuex'


const notif_api = new NotificationApi()

const api = new ApplicationApi()
export default {
  name: 'planning',
  mixins: [ snackbarMixin, filterSortMixin, modalMixin, storageMixin, filtersTemplatesMixin ],
  data() {
    return {
      promo: false,
      panel: [],
      choosedHeaders: [],
      filtredGroups: [],
      purchasePlans: [],
      isEmpty: false,
      creatorsData: [],
      departamentsData: {},
      categoriesData: {},
      selectedCount: 0,
      loading: false,
      all_categories: [],
      categories_plans: [],
      selectedItems: [],
      creators: [],
      filters: {}
    }
  },
  async mounted() {
    this.$root.$on('loadData', this.loadPlan)
    this.checkPromo()
  },
  beforeDestroy() {
    this.$root.$off('loadData', this.loadPlan)
  },
  computed: {
    categories: {
      get() {
        return this.categoriesData || {}
      },
      set(categories) {
        this.categoriesData = categories
      }
    },
    departaments: {
      get() {
        return this.departamentsData || {}
      },
      set(departaments) {
        this.departamentsData = departaments
      }
    },
    /*storage_filters() {
      return this.$_getStorageFilters(true)
    },*/
    rows() {
      let categories = {},
        departaments = {}
      if (!this.purchasePlans?.length) {
        return []
      }
      this.purchasePlans
        .forEach(row => {
          if (row.receiver && !departaments[row.receiver.name]) {
            departaments[row.receiver.name] = row.receiver
          }
          let code = row.resource?.category?.code
          if (code && !categories[code]) {
            categories[code] = row.resource.category.name
          }
        })

      if (Object.keys(departaments).length) {
        this.setDepartamentsData(departaments)
      }
      if (Object.keys(categories).length) {
        this.setCategoriesData(categories)
      }
      return this.purchasePlans
    },
    groups() {
      let groups =  [], rows = this.rows?.slice(0) || []
      if ( !rows?.length ) {
        return []
      }
      rows
        .forEach(row => {
          let date = row.approvedSupplyDate && !row.approvedPriority.id ? moment(row.approvedSupplyDate).format('MMMM YYYY') : row.approvedPriority.name
          date = this.bigFirstLetter(date)
          let item = groups.find( elem => elem.name == date)
          if (item) {
            item.items.push(row)
          } else {
            let time =  row.approvedSupplyDate && !row.approvedPriority.id ? moment(row.approvedSupplyDate).format('x')
              : row.approvedPriority.id != 'U' ? 1 : Math.max(...rows.map(row => +moment(row.approvedSupplyDate).format('x') || 0)) + 10
            groups.push({ name: date, items: [row], time: row.approvedSupplyDate || row.approvedPriority.id.trim() ? parseInt(time) : 0 })
          }
        })
      groups = groups.map((item, index) => ({...item, id: index}) )
      groups.forEach(group => {
        group.selectedItems = group.items.filter(elem => this.selectedItems.find(it => it.rowId == elem.rowId && it.headerId == elem.headerId))
      })
      return groups.sort((a, b) => a.time > b.time ? -1 : a.time < b.time ? 1 : 0)
    },
    headers() {
      return  [
        {text: '', value: 'data-table-select', width: '40',id: 0, setFilter: false },
        {text: this.$t('Planning.Name'), value: 'name',  sortable: true, type: 'text',  id: 1, class: 'planing-culumn', setFilter: false, disableFilter: true},
        {text: this.$t('Planning.DeliveryAddress'), value: 'receiver', width: '150', sortable: true, type: 'select', id: 2, class: 'planing-culumn', setFilter: true},
        {text: this.$t('Planning.Customer'), value: 'applicant', width: '210', sortable: true, type: 'select', id: 3, class: 'planing-culumn', setFilter: true },
        {text: this.$t('Planning.LastDate'), value: 'approvedSupplyDate', width: '180', sortable: true, type: 'date-field', id: 4, class: 'planing-culumn', setFilter: true},
        {text: this.$t('Planning.Amount'), value: 'quantity', width: '110', sortable: true, type: 'number', id: 5, class: 'planing-culumn', setFilter: false},
        {text: this.$t('Planning.SumTotal'), value: 'summa', width: '160', sortable: true, type: 'number', id: 6, class: 'planing-culumn', setFilter: false},
        {value: 'quantity', width: '50',type: 'number', id: 7, class: 'planing-culumn', setFilter: false},
        {class: 'planing-culumn hidden', id: 7, disableFilter: true, visible: false, setFilter: true, sortable: true, text: this.$t('Planning.ByCategories'), type: 'select', value: 'category', }
      ]
    },
    stored_filters() {
      return this.$store.getters.getFilters?.PLANS || {}
    },
    ...mapGetters({
      my_user_info: 'GET_USER',
      changeOrganisation: 'changeOrganisation',
    }),
  },
  methods: {
    loadPlan(update) {
      this.filters.filters =  update.filters ?? this.filters.filters
      this.filters.mode = update.filters_mode ?? this.filters.mode
      this.filters.search = update.search ?? (this.filters.search || '')
      this.loadData()
    },
    setOldScrollPosition() {
      if (!this.$route.meta.from.name) { return }

      const scrollTopId = this.$_getPropFromLocalStorage('planning.scrollTopId', 0)
      if (scrollTopId) {
        setTimeout(() => {
          if (document.getElementById(scrollTopId)) {
            document.getElementById(scrollTopId).scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
            this.$_savePropToLocalStorage('planning.scrollTopId', null)
          }
        }, 1000)
      }
    },
    async loadData() {
      if ( this.loading && this.$last_controller) {
        this.$last_controller.abort()
        this.$last_controller = null
      }
      // CATEGORIES        category
      // APPLICANTS        "applicant" 0: "*U3995"
      // DELIVERY_DATE     "approvedSupplyDate" 0: "2021-01-01" 1: "2021-12-31"
      // DELIVERY_ADDRESS  receiver 0: 4

      this.loading = true

      let fetch_by = this.filters.filters?.map(filter => {
          let result  = {
            filter: filter.id ,
            values: filter.search?.map(el => String( el.classificationCode || el )),
            contains: filter.contain
          }
          if ( result.filter == 'category') {
            result.filter = 'CATEGORIES'
          } else if ( result.filter == 'applicant') {
            result.filter = 'APPLICANTS'
          } else if  ( result.filter == 'approvedSupplyDate') {
            result.filter = 'DELIVERY_DATE'
          } else if  ( result.filter == 'receiver') {
            result.filter = 'DELIVERY_ADDRESS'
          }
          return result
        }),
        unionType = this.filters.mode ? 'AND' : 'OR'

      await this.$store.dispatch('getPurchasingPlans', {
        filters: fetch_by,
        unionType: fetch_by?.length ? unionType : null
      })
        .then( res => {
          this.purchasePlans = res?.items || []
          this.all_categories = res?.categories || []
          this.applySearch(this.filters.search)
        })
        .finally(() => {
          this.loading = false
          this.setOldScrollPosition()
        })

      this.choosedHeaders = this.headers
    },
    updateGroups(groups) {
      groups ||= this.$_.cloneDeep( this.groups)
      this.isEmpty = !groups.length

      this.filtredGroups = groups
      setTimeout(() => {
        this.panel = groups.map((el, index) => index)
      }, 100)
    },
    applySearch(search) {
      this.filters.search = search
      let groups = this.$_.cloneDeep( this.groups)

      if ( search ) {
        groups = this.$_.filter( groups, group => {
          group.items = this.$_.filter( group.items, row => {
            let res_name = row.resource?.name,
              lower_res_name = res_name?.toLowerCase().trim(),
              lower_descr = row.description?.toLowerCase().trim(),
              lower_search = search?.toLowerCase().trim(),
              highlight = text => `<span class="highlight-elastic">${text}</span>`,
              searched = ( res_name
                && lower_res_name?.includes(lower_search) )
                || ( lower_descr && lower_descr?.includes(lower_search) )
            if ( search && res_name && lower_res_name?.includes(lower_search) ) {
              row.name = lower_res_name?.replaceAll(lower_search, (match, pos) => {
                return highlight( res_name.substring(pos, pos + lower_search.length ))
              })
            } else {
              row.name = null
            }
            if (search && lower_descr?.includes(lower_search) ) {
              row.searched_description = lower_descr?.replaceAll(lower_search, (match, pos) => {
                return highlight( row.description.substring(pos, pos + lower_search.length ) )
              })
            } else {
              row.searched_description =  null
            }
            return searched
          })

          return group.items.length
        })
      }
      this.updateGroups( groups )
    },
    updateSelectedCount(gr) {
      this.selectedCount++
      var selectedItems = []
      this.groups.forEach(group => {
        if (gr.id == group.id) {
          group.selectedItems = gr.selectedItems
        }
        if (group.selectedItems?.length) {
          selectedItems = selectedItems.concat(group.selectedItems)
        }
      })
      this.selectedItems = selectedItems
      if (selectedItems.length > 0) {
        this.$_openSnackbar({
          name: 'planning',
          elements: selectedItems,
          callback: () => {
            this.selectedItems = []
            this.groups.forEach(group => group.selectedItems = [])
          },
          joinChat: async () => {
            await api.getApplicationChats(+selectedItems[0].headerId)
              .then(res => {
                let chats = res.data.chats, item_id = selectedItems[0].rowId,
                  chat = chats?.find(chat => chat.chatType?.trim() == 'ROW' && chat.chatKey?.trim()?.split('/')[1] == item_id )
                selectedItems[0].chat = chat
                if (!chat.chatUsers?.some(el => el.user.id == this.my_user_info?.purchasingSettings?.userId?.trim() )) {
                  notif_api.joinToChat( chat?.id )
                }

              })
          },
          user: this.my_user_info,
        })
      } else if (selectedItems.length == 0) {
        this.$_closeSnackbar()
      }
    },
    setCategoriesData (categories) {
      this.categories = categories
    },
    setDepartamentsData (departaments) {
      this.departaments = departaments
    },
    setFilters(filters, mode, search,) {
      search = this.filters.search || search || ''
      this.filters = { mode, filters: this.$_.cloneDeep(filters), search }
    },
    checkPromo() {
      return new Promise(async (resolve) => {
        const promo = this.$router.app.$acl.not.check('onlyApps')
        if (!promo) {
          this.loading = true
          this.creators = await this.$store.dispatch('getCreateOrdersUsers', true)
          let  checkActualFilters = ( filters ) => {
            if ( filters?.some(filt => filt.id == 'receiver' || filt.id == 'applicant') ) {

              let updated_filters = filters.filter(filt => {
                let receiver = filt.id == 'receiver' ,
                  creator = filt.id == 'applicant'
                if ( receiver ) {
                  filt.search = filt.search.filter(el => Object.values(this.departamentsData).some(it => el == it.id) )
                  receiver = receiver && !filt.search.length
                }
                if ( creator ) {
                  filt.search = filt.search.filter(el => this.creators.some(it => el == it?.id) )
                  creator = creator && !filt.search.length
                }
                return !receiver && !creator
              })
              if ( updated_filters?.length != filters?.length) {
                return updated_filters
              }  // якщо змінилась кількість фільтрів після відбору існуючих або кількість об'єктів в пошуку то обновляємо сторедж і самі фільтри
            }
            return filters
          }

          await this.updateFiltersFromStore( checkActualFilters )

          let settings = this.$store.getters.getSettings,
            access = settings?.userAccess,
            checkBilling = access?.checkBillingResult
          if (checkBilling?.showMessageByPayment) {
            this.$root.$emit('showLowBilingAlert' )
          }
        }
        this.promo = promo
        resolve(promo)
      })
    }
  },
  watch: {
    changeOrganisation( val ) {
      if ( !val ) {
        this.checkPromo()
      } else {
        this.purchasePlans = []
        this.filtredGroups = []
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.params && to.params.id) {
      this.$_savePropToLocalStorage('planning.scrollTopId', to.params.id)
    }
    next()
  },
  components: {
    PromoPage,
    EmptyBlock,
    TableFilters,
    PlanItemsTable,
    LowBalanceAlert
  }
}
</script>
<style lang="scss" scoped>
.planning {
  height: calc(100vh - 64px);
  overflow: auto;
  background: var(--color-main-green);
}
.title {
  font-size: 24px !important;
  line-height: 28px;
}
.planning-card {
  width: 100%;
  height: 100%;
  color: var(--text-color) !important;
}
.search-enter-active, .search-leave-active {
  transition: all  .36s ease;
}

.plan-header {
  // height: 44px;
  min-height: 44px;
  color: var(--text-color) !important;
}
// .group-title {
//   // height: 56px;
// }

.total-sum {
  font-size: 12px;
  line-height: 18px;
}

.plan-items {
  .item-title{
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: var(--text-color) !important;
  }
  .chip{
    height: 15px;
    background: var(--black-color);
    border-radius: 6px;
  }
}
</style>
